import React from 'react';

import Page from '@Containers/Page';
import Button from '@Components/Button';
import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';

import './Maintenance.theme.scss';

const supportCenterLink = 'https://service.elsevier.com/app/home/supporthub/reaxys/';

function Maintenance() {
  return (
    <Page
      withHeader
      headerType="clean"
      withFooter
      pageClassName="react-page-static maintenance-page"
      className="react-page-static__wrapper">
      <h1 className="react-page-static__heading">
        <span className="ss-mug" />
        &nbsp; Page Under Maintenance
      </h1>
      <div className="react-page-static__content">
        <p>
          We apologize for inconvenience. This service is unavailable due to a server update. We expect to be back soon.
          <br />
          Thanks for your patience.
        </p>
        <p>Please contact our support team if you have any questions</p>
        <p>
          <Button
            buttonConfig={{
              label: 'Contact Support Team',
              aTag: true,
              target: '_blank',
              href: supportCenterLink,
              type: 'link',
              size: 'sm',
              e2eName: 'contact-support-team',
            }}
            iconConfig={{
              name: 'chevron-right',
            }}
          />
        </p>
      </div>
    </Page>
  );
}

export default withCombinedRouteParams(Maintenance);
